import React, { Component } from "react";

class FilterGroup extends Component {
  render() {
    return (
      <div>
        <div
          id={this.props.id}
          className="filter-group-title"
          onClick={this.props.toggleHidden}
        >
          <div className="filter-icon">
            {this.props.isOpen ? (
              <i className="icon ion-arrow-down-b" />
            ) : (
              <i className="icon ion-arrow-right-b" />
            )}
          </div>

          {this.props.title}
        </div>
        {this.props.isOpen && (
          <div className="filter-content">{this.props.children}</div>
        )}
      </div>
    );
  }
}

export default FilterGroup;



// WEBPACK FOOTER //
// ./src/recherche/FilterGroup.js